/**
 *  sinaEmoji Module
 *
 * Description 表情包
 * Author: Qian.qianchen 2018-11-24
 */
angular.module('weiboSinaEmojiModule', [])
    .directive('weiboSinaEmoji', ['$q', 'trsHttpService', function($q, trsHttpService) {
        return {
            // name: '',
            // priority: 1,
            // terminal: true,
            scope: {
                emojiItem: "=",
                addEmoji: "&",
                selectType: "@",
                emojiStatus: "=",
                isShow:"="
                // notAllowDragPic: "@"
            }, // {} = isolate, true = child, false/undefined = no change
            // controller: function($scope, $element, $attrs, $transclude) {},
            // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
            restrict: 'E', // E = Element, A = Attribute, C = Class, M = Comment
            // template: '',
            templateUrl: './editingCenter/weibo/directive/sinaEmoji/sinaEmoji_tpl.html',
            replace: true,
            // transclude: true,
            // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
            link: function($scope, iElm, iAttrs, controller) {
                initStatus();
                initData();
                initBlur();
                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {}
                    $scope.data = {
                        items: [],
                    }
                }
                /**
                 * [initData description] 数据初始化
                 * @return {[type]} [description]
                 */
                function initData() {
                    var deferred = $q.defer();
                    trsHttpService.httpServer("./editingCenter/weibo/toBeCompiled/data/sinaEmoji.json", "", "get").then(function(data) {
                        $scope.data.items = data;
                        deferred.resolve();
                    });
                    return deferred.promise;
                }
                /**
                 * [closeEmoji description] 关闭选择表情弹窗
                 * @return {[type]} [description]
                 */
                $scope.closeEmoji = function() {
                    if (angular.isUndefined($scope.selectType)) {
                        $scope.emojiStatus = false;
                    } else if ($scope.selectType == 'origin') {
                        angular.isDefined($scope.emojiItem.emojiShow) ? $scope.emojiItem.emojiShow = false : $scope.emojiItem.originEmojiShow = false;
                    } else if ($scope.selectType == 'reply') {
                        angular.isDefined($scope.emojiItem.emojiShow) ? $scope.emojiItem.emojiShow = false : $scope.emojiItem.replyEmojiShow = false;
                    } else if ($scope.selectType == 'retweeted') {
                        $scope.emojiItem.retweetedEmojiShow = false;
                        angular.isDefined($scope.emojiItem.retweetedMicroContent.emojiShow) ? $scope.emojiItem.retweetedMicroContent.emojiShow = false : $scope.emojiItem.emojiShow = false;
                    }
                }
                /**
                 * [initElementEvent description] 初始化聚焦失焦事件
                 * @return {[type]} [description]
                 */
                function initBlur() {
                    var blur = function(e) {
                        var $target = $(e.target);
                        if ($target[0] !== iElm[0]) {
                            $scope.isShow = false;
                        }
                    }
                    $("body").bind("mouseup", blur);
                    $scope.$on("$destroy", function() {
                        $("body").unbind("mouseup", blur);
                    });
                }

            }
        }
    }]);